export default __webpack_public_path__ + "static/media/mti-macapp-icon.2f8feae9.png";